export function TodoList({ children }) {
  return <div className="todo-list">{children}</div>;
}
